import { render, staticRenderFns } from "./RentedMachineAdd.vue?vue&type=template&id=2c78fb2d&"
import script from "./RentedMachineAdd.vue?vue&type=script&lang=js&"
export * from "./RentedMachineAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports